import { render, staticRenderFns } from "./PageHeaderSearch.vue?vue&type=template&id=2771b208&scoped=true&"
import script from "./PageHeaderSearch.vue?vue&type=script&lang=js&"
export * from "./PageHeaderSearch.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderSearch.vue?vue&type=style&index=0&id=2771b208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2771b208",
  null
  
)

export default component.exports